import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            探索害羞草的世界
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            五大板块，从基础认知到深度探索，全方位了解这株神奇植物
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all hover:border-primary-200 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  title={`${cat.name} - 害羞草指南`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-6 h-6 flex items-center justify-center text-primary-500">
                    <i className={cat.icon}></i>
                  </span>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
          <Link
            to="/about"
            className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all hover:border-accent-200 cursor-pointer flex flex-col items-center justify-center p-6 md:p-8 text-center min-h-[200px]"
          >
            <span className="w-10 h-10 flex items-center justify-center text-2xl text-accent-500 mb-3">
              <i className="ri-heart-line"></i>
            </span>
            <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors mb-2">
              关于我们
            </h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              了解害羞草指南背后的故事与愿景
            </p>
          </Link>
        </div>
      </div>
    </section>
  );
}